
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { filter } from 'lodash';
import shortId from 'shortid';

// class name
// import cx from 'classnames';
import ProgressComponentList from '../../../../../../common/components/C_ProgressComponentList';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import Reference from './Reference';

// static constants
const formHeading = 'Additional Professional References';
const formText = `
  Please provide two additional work related references. We have your permission to contact these references. If you have letters of reference, you will be able to attach them in the Documents section.
`;

// styling obj
const addButtonStyle = {
  display: 'inline-block',
  top: '35px',
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};

export default class AdditionalReferences extends ProgressComponentList {

  static propTypes = {
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired
  }

  constructor(props, context) {
    super(props, context);
  }

  // Override ValidatedForm.validateForm()
  validateForm() {
    const referenceComponents = filter(this.refs, ref => ref.validateForm);

    const hasTwoReferences = referenceComponents.length >= 2;
    const sectionValidation = referenceComponents.reduce((valid, section) => section.validateForm() && valid, true);

    return sectionValidation && hasTwoReferences;
  }

  get newReference() {
    return {
      isNew: true,
      clientId: this.newClientId
    };
  }

  get newClientId() {
    return `${this.getIncrementedChar()}${shortId.generate()}`;
  }

  render() {

    const referenceArr = this.getList(false);
    const emptyReference = this.newReference;

    return (
      <div className='references-container application-section-container clearfix'>
          <div className='form-heading'>
            {formHeading}
          </div>
          <div className='form-text'>
            {formText}
          </div>
          {
            referenceArr.length
            &&
            referenceArr.map((reference, index, arr) =>
              <Reference
                key={reference.clientId}
                ref={reference.clientId}
                index={index}
                reference={reference}
                tempState={this.props.tempState}
                staticData={this.props.staticData}
                validation={this.props.validation}
                onChange={this.onChange.bind(this)}
                onRemove={this.removeListItem.bind(this)}
                showRemove={(arr.length > 1)}
              />
            )
            ||
            <Reference
              key={emptyReference.clientId}
              ref={emptyReference.clientId}
              index={0}
              reference={emptyReference}
              tempState={this.props.tempState}
              staticData={this.props.staticData}
              validation={this.props.validation}
              onChange={this.onChange.bind(this)}
              onRemove={this.removeListItem.bind(this)}
              showRemove={false}
            />
          }
          <FlatButton
            onClick={this.addListItem.bind(this)}
            style={{...addButtonStyle, ...(!referenceArr.length && {top: '10.5px'} || {})}}
            label='Add Reference'
          />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Background/c_AdditionalReferences/index.js